// extracted by mini-css-extract-plugin
export default {"dialog":"ErrorDialog_dialog__FUsa6"};